module.exports = __webpack_public_path__ + "img/loggigwi3.adfb5731.png";